import React from 'react'
import InputMask from 'react-input-mask'
import { Grid, TextField, Typography } from '@material-ui/core'
import BaseDialog from './general/BaseDialog'
import DatePicker from './general/DatePicker'
import { withStyles } from '@material-ui/core'
import { styles } from '../styles/js/baseDialog'

const DialogRecommendationComponent = ({
  classes,
  dialog,
  setDialog,
  formState,
  setFormState,
  create,
  statusRequestCreateEstabelecimento,
}) => {
  return (
    <BaseDialog
      dialog={dialog}
      setDialog={setDialog}
      title={'Indicar estabelecimento'}
      description={'Preencha os campos abaixo para indicar um estabelecimento.'}
      actionTitle={'Indicar'}
      actionStatusRequest={statusRequestCreateEstabelecimento.isLoading}
      secondaryActionTitle={null}
      handleAction={() => create(formState)}
      handleSecondaryAction={null}
      disabledAction={!formState.nome || !formState.bairro || !formState.cidade}
      slug={'filtrar'}
      fullWidth={true}
      maxWidth={'sm'}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant='h6' className={classes.label}>
            Qual é o nome do estabelecimento? <span style={{ color: 'red', fontSize: '0.8em' }}>(campo obrigatório)</span>
          </Typography>

          <TextField
            id='nome'
            name='nome'
            value={formState.nome || ''}
            onChange={(event) =>
              setFormState({
                ...formState,
                nome: event.target.value,
              })
            }
            placeholder={'Exemplo: Padaria da Dulcinéia'}
            variant='outlined'
            margin='none'
            fullWidth
            autoComplete='off'
            required
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant='h6' className={classes.label}>
            Em qual bairro esse lugar fica? <span style={{ color: 'red', fontSize: '0.8em' }}>(campo obrigatório)</span>
          </Typography>

          <TextField
            id='bairro'
            name='bairro'
            value={formState.bairro || ''}
            onChange={(event) =>
              setFormState({
                ...formState,
                bairro: event.target.value,
              })
            }
            placeholder={'Exemplo: Santa Felicidade'}
            variant='outlined'
            margin='none'
            fullWidth
            autoComplete='off'
            required
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant='h6' className={classes.label}>
            E em qual cidade? <span style={{ color: 'red', fontSize: '0.8em' }}>(campo obrigatório)</span>
          </Typography>

          <TextField
            id='cidade'
            name='cidade'
            value={formState.cidade || ''}
            onChange={(event) =>
              setFormState({
                ...formState,
                cidade: event.target.value,
              })
            }
            placeholder={'Exemplo: Curitiba'}
            variant='outlined'
            margin='none'
            fullWidth
            autoComplete='off'
            required
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant='h6' className={classes.label}>
            O que este lugar vende?
          </Typography>

          <TextField
            id='oQueVende'
            name='oQueVende'
            value={formState.oQueVende || ''}
            onChange={(event) =>
              setFormState({
                ...formState,
                oQueVende: event.target.value,
              })
            }
            placeholder={'Exemplo: Alimentos e Bebidas'}
            variant='outlined'
            margin='none'
            fullWidth
            autoComplete='off'
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant='h6' className={classes.label}>
            Se souber, indique o telefone:
          </Typography>

          <InputMask
            mask='(99) 9 9999 9999'
            maskChar=' '
            value={formState.telefone || ''}
            onChange={(event) =>
              setFormState({
                ...formState,
                telefone: event.target.value,
              })
            }
          >
            {() => (
              <TextField
                id='telefone'
                name='telefone'
                placeholder={'Exemplo: (41) 9 9999 9999'}
                variant='outlined'
                margin='none'
                fullWidth
                autoComplete='off'
                required
              />
            )}
          </InputMask>
        </Grid>

        <Grid item xs={12}>
          <Typography variant='h6' className={classes.label}>
            Se tiver alguma observação, inclua aqui:
          </Typography>

          <TextField
            id='observacoes'
            name='observacoes'
            value={formState.observacoes || ''}
            onChange={(event) =>
              setFormState({
                ...formState,
                observacoes: event.target.value,
              })
            }
            placeholder={'Escreva aqui informações adicionais...'}
            variant='outlined'
            margin='none'
            fullWidth
            autoComplete='off'
            multiline={true}
            rows={5}
          />
        </Grid>
      </Grid>
    </BaseDialog>
  )
}

export default withStyles(styles)(DialogRecommendationComponent)
